// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {

  apiKey: "AIzaSyBjxidtia8CewhTtYtVQ9nk4db53q6Z0Io",

  authDomain: "studentenausweisapp.firebaseapp.com",

  projectId: "studentenausweisapp",

  storageBucket: "studentenausweisapp.firebasestorage.app",

  messagingSenderId: "893156447242",

  appId: "1:893156447242:web:afc068071cbe3daceb3bf3"

};


const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const storage = getStorage(app);